module.exports = __webpack_public_path__ + "static/media/Sale_Post03-Image.60632597.jpg";